<ng-container appLabelCodeListener (labelCodeScanned)="labelCodeScanned($event)"></ng-container>
@switch (mode) {
  @case ("scan") {
    @if (!labelCode) {
      <div class="flex-col">
        <mat-icon class="qrcode-icon" svgIcon="mat_twotone:qr_code_scanner" aria-hidden="true" />
        <div>Waiting for QR code...</div>
      </div>
    } @else {
      @if (labelCode) {
        <div class="qrcode-svg">
          <qrcode
            [qrdata]="labelCode.asUri()"
            [elementType]="'svg'"
            [colorLight]="'#0000'"
            [colorDark]="'#222'"
            [width]="120"
            [margin]="0"
            [errorCorrectionLevel]="'M'"></qrcode>
        </div>
      }
        @if (labelCode && showScannedDetails && labelCode?.identifier) {
          <div class="identifier">
            Scanned QR code for {{ labelCode?.typeName }} {{ labelCode?.identifier?.slice(0, 4) }}...{{ labelCode.identifier.slice(-3) }}
          </div>
      }
    }
  }
  @case ("manual") {
    <mat-form-field class="manual" [formGroup]="manualFormGroup">
      <mat-label>Manually enter code</mat-label>
      <input matInput type="text" formControlName="manualEntry" maxlength="19" />
    </mat-form-field>
  }
}

@if (control?.touched && control?.invalid) {
  <div class="validation-errors">
    @if (control.errors?.required) {
      <mat-error>A QR code is required.</mat-error>
    }
    @if (control.errors?.invalidType) {
      <mat-error>
        QR code for {{ control.errors.invalidType.typeName | lowercase }} is not supported here; must be
        {{ control.errors.invalidType.requiredTypeNames | listAsWords: ", " : " or " | lowercase }}.
      </mat-error>
    }
    @for (error of control.errors?.labelCodeCustomErrors; track error.id) {
      <mat-error>{{ error.text }}</mat-error>
    }
  </div>
}
